import { API } from 'aws-amplify';

const getChallengeByIdApi = async (pk: string) => {
	return API.get(process.env.REACT_APP_NAME || '', '/challenge?pk=' + pk, {});
};

export { getChallengeByIdApi };
